import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import classes from './ErrorPage.module.scss';

const ErrorPage = (): JSX.Element => {
  const error = useRouteError();

  let errorMessage = 'An unexpected error occurred';
  let errorStatus = 500;

  if (isRouteErrorResponse(error)) {
    errorStatus = error.status;
    errorMessage = error.statusText || error.data?.message || errorMessage;

    // Handle 404 errors
    if (error.status === 404) {
      errorMessage = 'Page not found';
    }
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  console.error('Route error:', error);

  return (
    <div className={classes.errorPage}>
      <div className={classes.container}>
        <div className={classes.icon}>⚠️</div>
        <h1 className={classes.title}>{errorStatus}</h1>
        <h2 className={classes.subtitle}>Oops! Something went wrong</h2>
        <p className={classes.message}>{errorMessage}</p>
        <div className={classes.actions}>
          <Link to="/" className={classes.button}>
            Go Home
          </Link>
          <button
            onClick={() => window.location.reload()}
            className={`${classes.button} ${classes.secondary}`}
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
